import React, { ReactElement, ReactNode } from 'react';

export default function GrayTextComponent({ children }: { children: ReactNode }): ReactElement {
  return <p className="text-gray-100">{children}</p>;
}
